






import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { IStyle } from '~/assets/interfaces/classes'

@Component
export default class ComponentAlert extends Vue {
  @Prop({ type: String, default: '' }) private type!: string

  private $style!: IStyle

  private get classAlert() {
    return {
      [this.$style.item]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.error]: this.type === 'error',
      [this.$style.secondary]: this.type === 'secondary',
      [this.$style.success]: this.type === 'success',
      [this.$style.primary]: this.type === 'primary',
      [this.$style.info]: this.type === 'info',
      [this.$style.gray]: this.type === 'gray',
    }
  }

  private mounted() {
    this.$emit('loaded')
  }
}
